import _ from 'lodash';
import { getValues } from 'redux-form';

import { buildApplicationState } from '../helpers/applicationManager';
import { getCookie } from '../helpers/helpers';
import * as APISelectors from '../lendingAPI/lendingAPISelector';
import { MERCHANT_CASH_ADVANCE_PRODUCT_TYPE } from '../lendingAPI/productTypes.constants';

const truthyValues = ['True', 'true', true];

export const getSplitTestValue = (state, splitTestName) => {
    const overrideCookie = getCookie(`splittest_${splitTestName}`);
    if (overrideCookie !== null) return truthyValues.includes(overrideCookie);

    const splitTests = APISelectors.getSplitTests(state);
    const splitTestValue = _.find(
        splitTests,
        (test) => test[splitTestName] !== undefined
    );

    return _.get(splitTestValue, splitTestName, false);
};

export const getRequestedAmount = (state) => {
    const requestedAmountFromAPI = APISelectors.getRequestedAmount(state);

    const requestedAmountFromForm = _.get(
        getValues(_.get(state, 'form.sign_up')),
        'loanRequestDetails.loan_request.amount'
    );

    return requestedAmountFromAPI || requestedAmountFromForm;
};

export const getCustomerApplicationState = (state) => {
    const formValues = getValues(state.form.sign_up);
    const application = _.get(state, 'fetched.application.payload');

    return buildApplicationState(application, formValues);
};

export const isSoleTrader = (state) => {
    const companyType = getCompanyType(state);
    return ['st', 'op', 'other'].includes(companyType);
};

export const getCompanyType = (state) =>
    _.get(getCustomerApplicationState(state), 'company.type');

export const getProviders = (state) =>
    _.get(getCustomerApplicationState(state), 'company.providers');

export const getVATStatus = (state) =>
    _.get(getCustomerApplicationState(state), 'company.vat_registered_status');

export const isDeRBLLoan = (state) => {
    return (
        APISelectors.getRequestedProductType(state) ===
            MERCHANT_CASH_ADVANCE_PRODUCT_TYPE &&
        APISelectors.getCountryCode(state) === 'de'
    );
};

export const showIOWithoutLightningLoan = (state) =>
    _.get(state, 'ui.attributes.show_io_without_ll');
